// Güncellenen: KazaTopluYukle.js
// Özellik: Tarih alanı Timestamp olarak kaydedilir

import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import {
  collection,
  getDocs,
  addDoc,
  serverTimestamp,
  Timestamp,
} from "firebase/firestore";
import { db, auth } from "../firebaseConfig";

const KazaTopluYukle = () => {
  const [validPlakalar, setValidPlakalar] = useState(new Set());
  const [validPersoneller, setValidPersoneller] = useState(new Set());
  const [rapor, setRapor] = useState([]);
  const [excelData, setExcelData] = useState([]);

  useEffect(() => {
    const fetchValidData = async () => {
      const plakaSnap = await getDocs(collection(db, "plates"));
      const personelSnap = await getDocs(collection(db, "personeller"));

      const plakalar = new Set(plakaSnap.docs.map((doc) => doc.data().plate?.trim()));
      const personeller = new Set(
        personelSnap.docs.map((doc) => {
          const data = doc.data();
          const ad = typeof data.ad === "string" ? data.ad.trim() : "";
          const soyad = typeof data.soyad === "string" ? data.soyad.trim() : "";
          return `${ad} ${soyad}`;
        })
      );

      setValidPlakalar(plakalar);
      setValidPersoneller(personeller);
    };

    fetchValidData();
  }, []);

  const parseExcelDate = (dateInput) => {
    if (!dateInput) return null;
    if (typeof dateInput === "number") {
      const jsDate = new Date((dateInput - 25569) * 86400 * 1000);
      return Timestamp.fromDate(jsDate);
    }
    const parts = dateInput.toString().split(/[./-]/);
    if (parts.length === 3) {
      const [d1, d2, d3] = parts.map((v) => parseInt(v, 10));
      const jsDate = dateInput.includes("/") || dateInput.includes("-")
        ? new Date(d3, d2 - 1, d1)
        : new Date(d1, d2 - 1, d3);
      return Timestamp.fromDate(jsDate);
    }
    return null;
  };

  const convertExcelTime = (excelTime) => {
    if (typeof excelTime === "number") {
      const totalSeconds = Math.round(86400 * excelTime);
      const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
      const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
      return `${hours}:${minutes}`;
    }
    return excelTime;
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const workbook = XLSX.read(bstr, { type: "binary" });
      const sheet = workbook.Sheets["KAZALAR"];
      const jsonData = XLSX.utils.sheet_to_json(sheet);
      setExcelData(jsonData);
    };
    reader.readAsBinaryString(file);
  };

  const handleUploadClick = async () => {
    const currentUser = auth.currentUser;
    if (!currentUser) return alert("Kullanıcı giriş yapmamış!");

    const hataliKayitlar = [];

    for (const row of excelData) {
      const plaka = row["AraçPlakası"]?.toString().trim();
      const personel = row["Kazaya Yapan Personel"]?.toString().trim();
      const tarih = parseExcelDate(row["Tarih"]);
      const saat = convertExcelTime(row["Kaza Saati"]);

      if (!validPlakalar.has(plaka) || !validPersoneller.has(personel) || !tarih) {
        hataliKayitlar.push({
          Plaka: plaka,
          Personel: personel,
          Neden: `${!validPlakalar.has(plaka) ? "Plaka yok" : ""} ${!validPersoneller.has(personel) ? "Personel yok" : ""} ${!tarih ? "Tarih hatalı" : ""}`.trim(),
        });
        continue;
      }

      try {
        await addDoc(collection(db, "kazalar"), {
          tarih,
          saat: saat || "",
          plaka,
          personel,
          kazaBasligi: row["Kaza Başlığı"] || "",
          aciklama: row["Açıklama"] || "",
          kazaFotoURL: [],
          raporURL: "",
          createdBy: currentUser.email,
          createdAt: serverTimestamp(),
        });
      } catch (err) {
        hataliKayitlar.push({ Plaka: plaka, Personel: personel, Neden: "Firestore kayıt hatası" });
      }
    }

    if (hataliKayitlar.length > 0) {
      setRapor(hataliKayitlar);
      alert("Bazı kayıtlar yüklenemedi. Detaylar aşağıda.");
    } else {
      setRapor([]);
      alert("Tüm kazalar başarıyla yüklendi.");
    }
  };

  const handleTemplateDownload = () => {
    const ws = XLSX.utils.json_to_sheet([
      {
        "Kazaya Yapan Personel": "Ali Yılmaz",
        "AraçPlakası": "06ABC123",
        Tarih: "01.01.2024",
        "Kaza Saati": "14:30",
        "Kaza Başlığı": "Takip Mesafesi",
        Açıklama: "Kırmızı ışıkta duramadı."
      },
    ]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "KAZALAR");
    XLSX.writeFile(wb, "kaza_excel_sablon.xlsx");
  };

  return (
    <div className="form-container">
      <h2>Excel'den Toplu Kaza Yükle</h2>
      <button onClick={handleTemplateDownload}>Örnek Excel Şablonunu İndir</button>
      <br /><br />
      <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />
      <br /><br />
      <button onClick={handleUploadClick} disabled={excelData.length === 0}>Yüklemeyi Başlat</button>
    </div>
  );
};

export default KazaTopluYukle;
